export default __webpack_public_path__ + "static/media/mongoDb.8b20217d.webp";